import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { createTraitApi, storeTraitApi } from './traitSlice';
import isEmpty from 'lodash/isEmpty';
import TraitForm from './TraitForm';

function TraitCreate() {
    const { model: initialValues } = useSelector((state) => state.heroSaga.trait);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [searchParams] = useSearchParams();
    const type = searchParams.get('type');

    const formSubmit = async (values) => {
        dispatch(storeTraitApi({ navigate, values, type }));
    };

    useEffect(() => {
        if (isEmpty(initialValues)) {
            dispatch(createTraitApi({ type, navigate }));
        }
    }, []);

    return (
        <TraitForm
            initialValues={initialValues}
            type={type}
            formSubmit={formSubmit}
        />
    );
}

export default TraitCreate;
